import * as scrollingModuleActions from '../../action_creators/homepage/scrolling_module_action_creators';
import ScrollingModuleModel from '../../../models/homepage/scrolling_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(scrollingModuleActions.scrollingModuleLoading({}, store));
    return ScrollingModuleModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(
          scrollingModuleActions.scrollingModuleLoaded(resp.data, store)
        );
      })
      .catch(function handleUserError(err) {
        dispatch(scrollingModuleActions.scrollingModuleLoadError(err, store));
        log.error(
          err,
          `Error in scrollingModule actions, message: ${err.message}`
        );
      });
  };
}
